import React from 'react';
import { useRecoilValue, useResetRecoilState } from 'recoil';

import { infoModalState } from 'state/atoms';
import { Modal } from 'components/Modal';

const InfoModal = () => {
  const { open, config = {} } = useRecoilValue(infoModalState);
  const resetModal = useResetRecoilState(infoModalState);

  return (
    <Modal
      isOpen={open}
      onConfirmation={resetModal}
      onDismiss={resetModal}
      position="top"
      {...config}
    />
  );
};

export { InfoModal };
